import {
    SET_CRITERES_RANKING,
} from './mutations-type'

var _ = require('underscore');

// initial state
const state = {
    criteres: null,
}

// mutations
const mutations = {
    [SET_CRITERES_RANKING](state, message) {
        state.criteres = message;
    },


}

const actions = {
    setCriteresRanking({commit}, msg) {
        commit(SET_CRITERES_RANKING, msg)
    },
}

const getters = {
    getCriteresRanking: state => {
        return state.criteres;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/vuex/store-ranking.js